module.exports = __webpack_public_path__ + "static/media/vent-direccio-40.94753bef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/vent-direccio-40.svg
// module id = 206
// module chunks = 0